import { inject } from '@angular/core';

import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { OperatorFunction, filter, map, pipe } from 'rxjs';

import { selectIsLinearBetslip } from '../../base/store/selectors';

export function ensureLinearMode<T extends Action>(store: Store): OperatorFunction<T, T> {
    return pipe(
        concatLatestFrom(() => store.select(selectIsLinearBetslip)),
        filter(([_, isLinearMode]) => isLinearMode),
        map(([action]) => action),
    );
}

export function ensureTabbedMode<T extends Action>(store: Store): OperatorFunction<T, T> {
    return pipe(
        concatLatestFrom(() => store.select(selectIsLinearBetslip)),
        filter(([_, isLinearMode]) => !isLinearMode),
        map(([action]) => action),
    );
}

export function ensureTabbedBetslip<T extends Action>(): OperatorFunction<T, T> {
    const store = inject(Store);

    return ensureTabbedMode<T>(store);
}

export function ensureLinearBetslip<T extends Action>(): OperatorFunction<T, T> {
    const store = inject(Store);

    return ensureLinearMode<T>(store);
}
